// Import dependencies
import { initialiser } from '../../ramen-imports/utilitybelt';

class Video {
  constructor(config) {
    const { el, settings } = config;

    // Set module dom elements
    this.container = el;
    this.button = el.querySelector(settings.button);
    this.videoFrame = el.querySelector('iframe');
    this.nativeVideo = el.querySelector('video');
  }

  // Initialisation Function
  init = () => {
    this.button.addEventListener('click', this.handleButtonClick);
  };

  handleButtonClick = () => {
    setTimeout(() => {
      this.container.classList.add('is-playing');
    }, 500);

    if (this.nativeVideo) {
      this.nativeVideo.autoplay = true;
      this.nativeVideo.play();
      return;
    }

    // Start playing video as soon as frame appears
    const updatedSrc = this.replaceSrc(this.videoFrame.getAttribute('src'));
    this.videoFrame.setAttribute('src', updatedSrc);
  };

  replaceSrc = (src) => src.replace('autoplay=0', 'autoplay=1');
}

export default (settings) => initialiser(settings, Video);
